export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -84, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const whatsappLink = (message = "") => {
  const rawNum = process.env.REACT_APP_WHATSAPP_NUMBER || "34652463252";
  const digits = String(rawNum).replace(/\D/g, "");
  const num = digits.startsWith("34") ? digits : (digits.length === 9 ? `34${digits}` : digits);
  return `https://wa.me/${num}?text=${encodeURIComponent(message || "")}`;
};
